import React, {useEffect, useState} from "react";
import {Calendar} from "../../system/calendar/calendar";
import jalaali from "jalaali-js";
import SelectInput from "../../system/select";
import {getAgentsList} from "../../../services/agent/agent";
import {
  getBackOfficeAgentMonthSchedule,
  submitBackOfficeSchedule,
  updateBackOfficeSchedule
} from "../../../services/back_office/schedule";
import {Typography} from "@material-tailwind/react";


export function BackOfficeScheduleManagement() {

  const [schedules, setSchedules] = useState([]);
  const [lastDataRefresh, setLastDataRefresh] = useState(Date.now)

  const [agentId, setAgentId] = useState(null);

  async function getData(jy, jm, monthDays) {
    if (agentId) {
      const result = await getBackOfficeAgentMonthSchedule(jy, jm, monthDays, agentId);
      if (result.status === 200) {
        const {scheduleList} = result.data;
        setSchedules(scheduleList || []);
      }
    }
  }

  useEffect(() => {
    const {jy, jm} = jalaali.toJalaali(new Date())
    const monthDays = jalaali.jalaaliMonthLength(jy, jm);
    getData(jy, jm, monthDays);
  }, [lastDataRefresh, agentId]);

  const save = async (id, title, from, to, startDate, endDate, weekDayId) => {
    const data = {
      id: id,
      title: title,
      start_time: from,
      end_time: to,
      start_date: startDate,
      end_date: endDate,
      week_day_id: weekDayId,
      agent_id: agentId,
    };
    let result;

    if (!id) {
      result = await submitBackOfficeSchedule(data);
    } else {
      result = await updateBackOfficeSchedule(data);
    }

    if (result.status === 200) {
      setLastDataRefresh(Date.now())
    }

  };

  return (
    <div className="flex flex-col w-full bg-white gap-4">

      <div className="mb-8 flex items-center justify-between mt-2">
        <Typography variant="h5" color="blue-gray">برنامه زمان‌بندی</Typography>
      </div>

      <div className="flex flex-col mb-4 overflow-y-visible w-full md:w-1/2">
        <SelectInput
          label={"کاربر"}
          defaultValue={agentId}
          refreshSignal={agentId}
          // multiselect={false}
          autoLoadService={getAgentsList}
          autoLoadRender={({name, family, phone}) => {
            const fullName = `${name?.trim()} ${family?.trim()}`.trim();
            return fullName + " - " + phone
          }}
          onChange={setAgentId}
        />
      </div>

      <Calendar
        Type="schedule"
        eventList={schedules}
        setEventList={setSchedules}
        setLastDataRefresh={setLastDataRefresh}
        lastDataRefresh={lastDataRefresh}
        onEvent={(id, title, from, to, startDate, endDate, weekDayId) => {
          save(id, title, from, to, startDate, endDate, weekDayId)
        }}
        onNavigate={(jy, jm, monthDays) => {
          getData(jy, jm, monthDays);
        }}
      />
    </div>
  );
}